import "@/App.css";
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
} from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import Program from "@/pages/Program";
import HowItWorks from "@/pages/HowItWorks";
import Results from "@/pages/Results";
import FAQ from "@/pages/FAQ";
import Book from "@/pages/Book";
import Pricing from "@/pages/Pricing";
import PaySuccess from "@/pages/PaySuccess";
import Apply from "@/pages/Apply";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Prospects from "@/pages/admin/Prospects";
import Clients from "@/pages/admin/Clients";
import Finances from "@/pages/admin/Finances";
import Applications from "@/pages/admin/Applications";
import { AuthProvider } from "@/contexts/AuthContext";
import usePageView from "@/hooks/usePageView";

function isChromelessPath(pathname) {
    return pathname.startsWith("/admin") || pathname.startsWith("/login");
}

function PageViewTracker() {
    usePageView();
    return null;
}

function AppRoutes() {
    const location = useLocation();
    const showChrome = !isChromelessPath(location.pathname);

    // Handle Emergent Auth callback (session_id in URL fragment) before route matching
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }

    return (
        <>
            {showChrome && <Header />}
            <PageViewTracker />
            <main className="relative z-10">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/program" element={<Program />} />
                    <Route path="/how-it-works" element={<HowItWorks />} />
                    <Route path="/results" element={<Results />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/book" element={<Book />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/pay/success" element={<PaySuccess />} />
                    <Route path="/apply" element={<Apply />} />
                    <Route path="/apply/:token" element={<Apply />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/admin" element={<AdminLayout />}>
                        <Route index element={<Overview />} />
                        <Route path="prospects" element={<Prospects />} />
                        <Route path="clients" element={<Clients />} />
                        <Route path="applications" element={<Applications />} />
                        <Route path="finances" element={<Finances />} />
                    </Route>
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </main>
            {showChrome && <Footer />}
        </>
    );
}

function App() {
    return (
        <div className="App grain">
            <BrowserRouter>
                <AuthProvider>
                    <AppRoutes />
                    <Toaster
                        theme="dark"
                        position="top-right"
                        toastOptions={{
                            style: {
                                background: "#060c1e",
                                border: "1px solid #1a2a4a",
                                color: "#fff",
                            },
                        }}
                    />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
